export const VIDEO_PLAYER_COLORS = {
  /* we want to use the white color both in light and dark mode */
  WHITE: '#ffffff',
} as const;
